import React, { useState, useEffect } from 'react';
import HomePage from './pages/HomePage';
import MomentlistaPage from './pages/MomentlistaPage';
import BookingPage from './pages/BookingPage';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import EmployeePage from './pages/EmployeePage';
import LoginPage from './pages/LoginPage';
import CustomerDashboard from './pages/CustomerDashboard';
import AdminDashboard from './components/AdminDashboard';
import RutPage from './pages/RutPage';
import './App.css';

function App() {
const [currentPage, setCurrentPage] = useState('home');
const [currentUser, setCurrentUser] = useState(null);
const [menuOpen, setMenuOpen] = useState(false);
const [scrolled, setScrolled] = useState(false);
const [preselectService, setPreselectService] = useState(null);
const [currentMomentlista, setCurrentMomentlista] = useState('djupstadning');

useEffect(() => {
const handleScroll = () => setScrolled(window.scrollY > 50);
window.addEventListener('scroll', handleScroll);
return () => window.removeEventListener('scroll', handleScroll);
}, []);

useEffect(() => {
const savedUser = localStorage.getItem('galax_current_user');
if (savedUser && localStorage.getItem('galax_token')) setCurrentUser(JSON.parse(savedUser));
else if (savedUser) localStorage.removeItem('galax_current_user');
const path = window.location.pathname;
if (path === '/karriar' || path === '/karriar/') setCurrentPage('careers');
else if (path === '/boka' || path === '/boka/') setCurrentPage('booking');
else if (path === '/kontakt' || path === '/kontakt/') setCurrentPage('contact');
else if (path === '/om-oss' || path === '/om-oss/') setCurrentPage('about');
else if (path === '/team' || path === '/team/') setCurrentPage('team');
else if (path === '/personal' || path === '/personal/') setCurrentPage('employee');
else if (path === '/login' || path === '/login/') setCurrentPage('login');
else if (path === '/rut' || path === '/rut/') setCurrentPage('rut');
}, []);

const handleLogin = (user) => {
setCurrentUser(user);
localStorage.setItem('galax_current_user', JSON.stringify(user));
if (user.role === 'admin') setCurrentPage('admin');
else if (user.role === 'employee') setCurrentPage('employee');
else setCurrentPage('customer-dashboard');
window.scrollTo({ top: 0, behavior: 'smooth' });
};

const handleUserUpdate = (u) => {
  setCurrentUser(u);
  localStorage.setItem('galax_current_user', JSON.stringify(u));
};

const handleLogout = () => {
setCurrentUser(null);
localStorage.removeItem('galax_current_user');
localStorage.removeItem('galax_employee');
localStorage.removeItem('galax_token');
setCurrentPage('home');
window.scrollTo({ top: 0, behavior: 'smooth' });
};

const handleNavigate = (page, extra = null) => {
if (page === 'momentlista' && extra) {
setCurrentMomentlista(extra);
}
if (page === 'booking' && extra && extra !== null && typeof extra === 'string' && page !== 'momentlista') {
setPreselectService(extra);
}
setCurrentPage(page);
setMenuOpen(false);
setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 50);
};

const handleBookingComplete = (booking) => {
console.log('New booking created:', booking);
};

const showFooter = ['home', 'booking', 'about', 'team', 'careers', 'contact', 'rut'].includes(currentPage);

const tjänsterMenu = [
{ key: 'djupstadning', label: 'Djupstädning' },
{ key: 'standardstadning', label: 'Standardstädning' },
{ key: 'flyttstadning', label: 'Flyttstädning' },
{ key: 'fonsterputs', label: 'Fönsterputs' },
{ key: 'kontorsstadning', label: 'Kontorsstädning' },
{ key: 'flytthjalp', label: 'Flytthjälp' },
{ key: 'manadspaket', label: 'Månadspaket' },
{ key: 'minipaket', label: 'Minipaket' }
];

return (
<div className="min-h-screen" style={{ backgroundColor: '#f8f7f4', color: '#1a1a2e' }}>

{/* Floating Stars */}
<div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
{[...Array(40)].map((_, i) => (
<div key={i} className="absolute star-float"
style={{
top: Math.random() * 100 + '%',
left: Math.random() * 100 + '%',
animationDelay: Math.random() * 6 + 's',
animationDuration: (Math.random() * 4 + 4) + 's',
opacity: Math.random() * 0.15 + 0.05,
}}>
<svg width={Math.random() * 12 + 6} height={Math.random() * 12 + 6} viewBox="0 0 24 24" fill="#C9A84C">
<polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/>
</svg>
</div>
))}
</div>

{/* Navbar */}
<nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'shadow-lg' : ''}`}
style={{ backgroundColor: scrolled ? 'rgba(248,247,244,0.97)' : 'rgba(248,247,244,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #e8e4d9' }}>
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
<div className="flex items-center justify-between h-20">

{/* Logo */}
<div className="flex items-center space-x-3 cursor-pointer" onClick={() => handleNavigate('home')}>
<svg width="40" height="40" viewBox="0 0 40 40">
<circle cx="20" cy="20" r="20" fill="#1a1a2e"/>
<polygon points="20,8 23.5,16 32,17 26,23 27.5,32 20,28 12.5,32 14,23 8,17 16.5,16" fill="#C9A84C"/>
</svg>
<div>
<h1 className="text-2xl font-bold tracking-widest" style={{ color: '#1a1a2e', letterSpacing: '0.2em' }}>GALAX</h1>
<p className="text-xs tracking-widest" style={{ color: '#C9A84C', letterSpacing: '0.3em' }}>ELITE STÄD</p>
</div>
</div>

{/* Desktop Nav */}
<div className="hidden md:flex items-center space-x-2">
{[
{ key: 'home', label: 'Hem' },
{ key: 'about', label: 'Om Oss' },
{ key: 'team', label: 'Team' },
{ key: 'careers', label: 'Karriär' },
{ key: 'contact', label: 'Kontakt' },
].map(({ key, label }) => (
<button key={key} onClick={() => handleNavigate(key)}
className="px-4 py-2 font-semibold transition-all rounded-lg text-sm"
style={{
color: currentPage === key ? '#C9A84C' : '#555',
borderBottom: currentPage === key ? '2px solid #C9A84C' : '2px solid transparent',
background: 'none'
}}>
{label}
</button>
))}

{/* Tjänster dropdown */}
<div className="relative group">
<button className="px-4 py-2 font-semibold transition-all rounded-lg text-sm"
style={{ color: currentPage === 'momentlista' ? '#C9A84C' : '#555', background: 'none', borderBottom: currentPage === 'momentlista' ? '2px solid #C9A84C' : '2px solid transparent' }}>
Tjänster ▾
</button>
<div className="absolute top-full left-0 mt-2 w-56 rounded-2xl shadow-xl overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50"
style={{ backgroundColor: '#1a1a2e', border: '1px solid rgba(201,168,76,0.3)' }}>
{tjänsterMenu.map(item => (
<button key={item.key}
onClick={() => handleNavigate('momentlista', item.key)}
className="w-full text-left px-4 py-3 text-sm font-semibold transition-all hover:bg-white hover:bg-opacity-10"
style={{ color: '#fff', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
{item.label}
</button>
))}
</div>
</div>

<button onClick={() => handleNavigate('booking')}
className="ml-4 px-6 py-3 rounded-full font-bold text-sm transition-all hover:scale-105"
style={{ backgroundColor: '#1a1a2e', color: '#C9A84C', border: '2px solid #C9A84C' }}>
Boka Nu
</button>

{!currentUser ? (
<button onClick={() => handleNavigate('login')}
className="px-4 py-2 rounded-full font-bold text-sm transition-all"
style={{ backgroundColor: '#f8f7f4', color: '#555', border: '2px solid #e8e4d9' }}>
Logga In
</button>
) : (
<div className="flex items-center gap-2">
<button onClick={() => {
if (currentUser.role === 'admin') handleNavigate('admin');
else if (currentUser.role === 'employee') handleNavigate('employee');
else handleNavigate('customer-dashboard');
}}
className="px-4 py-2 rounded-full font-bold text-sm transition-all"
style={{ backgroundColor: 'rgba(201,168,76,0.1)', color: '#1a1a2e', border: '2px solid #C9A84C' }}>
👋 Hej, {currentUser.name.split(' ')[0]}!
</button>
<button onClick={handleLogout}
className="px-3 py-2 rounded-full font-semibold text-sm"
style={{ backgroundColor: '#fee2e2', color: '#dc2626' }}>
Logga Ut
</button>
</div>
)}
</div>

{/* Mobile menu button */}
<button className="md:hidden p-2" onClick={() => setMenuOpen(!menuOpen)}
style={{ color: '#1a1a2e' }}>
<svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
{menuOpen ? <path d="M6 18L18 6M6 6l12 12"/> : <><path d="M3 12h18"/><path d="M3 6h18"/><path d="M3 18h18"/></>}
</svg>
</button>
</div>

{/* Mobile Menu */}
{menuOpen && (
<div className="md:hidden pb-4 border-t" style={{ borderColor: '#e8e4d9' }}>
{[
{ key: 'home', label: 'Hem' },
{ key: 'about', label: 'Om Oss' },
{ key: 'team', label: 'Team' },
{ key: 'careers', label: 'Karriär' },
{ key: 'contact', label: 'Kontakt' },
].map(({ key, label }) => (
<button key={key} onClick={() => handleNavigate(key)}
className="block w-full text-left px-4 py-3 font-semibold"
style={{ color: currentPage === key ? '#C9A84C' : '#555' }}>
{label}
</button>
))}

{/* Mobile Tjänster */}
<div className="px-4 py-2">
<p className="text-xs font-bold tracking-widest mb-2" style={{ color: '#C9A84C' }}>TJÄNSTER — MOMENTLISTOR</p>
<div className="grid grid-cols-2 gap-1">
{tjänsterMenu.map(item => (
<button key={item.key}
onClick={() => handleNavigate('momentlista', item.key)}
className="text-left px-3 py-2 rounded-lg text-sm font-semibold"
style={{ color: '#555', backgroundColor: '#f3f4f6' }}>
{item.label}
</button>
))}
</div>
</div>

<div className="px-4 pt-2 flex flex-col gap-2">
<button onClick={() => handleNavigate('booking')}
className="px-6 py-3 rounded-full font-bold text-sm"
style={{ backgroundColor: '#1a1a2e', color: '#C9A84C', border: '2px solid #C9A84C' }}>
Boka Nu
</button>
{!currentUser ? (
<button onClick={() => handleNavigate('login')}
className="px-6 py-3 rounded-full font-bold text-sm"
style={{ backgroundColor: '#f8f7f4', color: '#555', border: '2px solid #e8e4d9' }}>
Logga In
</button>
) : (
<>
<button onClick={() => {
if (currentUser.role === 'admin') handleNavigate('admin');
else if (currentUser.role === 'employee') handleNavigate('employee');
else handleNavigate('customer-dashboard');
}}
className="px-6 py-3 rounded-full font-bold text-sm"
style={{ backgroundColor: 'rgba(201,168,76,0.1)', color: '#1a1a2e', border: '2px solid #C9A84C' }}>
👋 Hej, {currentUser.name.split(' ')[0]}!
</button>
<button onClick={handleLogout}
className="px-6 py-3 rounded-full font-bold text-sm"
style={{ backgroundColor: '#fee2e2', color: '#dc2626' }}>
Logga Ut
</button>
</>
)}
</div>
</div>
)}
</div>
</nav>

{/* Main Content */}
<div className="relative z-10">
{currentPage === 'home' && <HomePage onNavigate={handleNavigate} />}
{currentPage === 'booking' && (
<BookingPage
onBookingComplete={handleBookingComplete}
preselectService={preselectService}
onClearPreselect={() => setPreselectService(null)}
currentUser={currentUser}
onNavigate={handleNavigate}
/>
)}
{currentPage === 'about' && <AboutPage />}
{currentPage === 'team' && <TeamPage />}
{currentPage === 'careers' && <CareersPage />}
{currentPage === 'contact' && <ContactPage />}
{currentPage === 'login' && <LoginPage onLogin={handleLogin} onNavigate={handleNavigate} />}
{currentPage === 'rut' && <RutPage onNavigate={handleNavigate} />}
{currentPage === 'momentlista' && (
<MomentlistaPage service={currentMomentlista} onNavigate={handleNavigate} />
)}
{currentPage === 'customer-dashboard' && currentUser && (
<CustomerDashboard user={currentUser} onNavigate={handleNavigate} onUserUpdate={handleUserUpdate} />
)}
{currentPage === 'employee' && (
<EmployeePage employee={currentUser} onLogout={handleLogout} />
)}
{currentPage === 'admin' && currentUser?.role === 'admin' && (
<div className="pt-32 px-4">
<AdminDashboard onLogout={handleLogout} />
</div>
)}
</div>

{/* Footer */}
{showFooter && (
<footer className="relative z-10 mt-24 py-16" style={{ backgroundColor: '#1a1a2e', color: '#e8e4d9' }}>
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
<div className="grid md:grid-cols-4 gap-8 mb-12">
<div>
<div className="flex items-center space-x-3 mb-4">
<svg width="36" height="36" viewBox="0 0 40 40">
<circle cx="20" cy="20" r="20" fill="#C9A84C"/>
<polygon points="20,8 23.5,16 32,17 26,23 27.5,32 20,28 12.5,32 14,23 8,17 16.5,16" fill="#1a1a2e"/>
</svg>
<div>
<h3 className="text-xl font-bold tracking-widest">GALAX</h3>
<p className="text-xs tracking-widest" style={{ color: '#C9A84C' }}>ELITE STÄD</p>
</div>
</div>
<p className="text-sm" style={{ color: '#9ca3af' }}>Motalas första elite städteam. Precision. Harmoni. Perfektion.</p>
</div>
<div>
<h4 className="font-bold mb-4 tracking-wider" style={{ color: '#C9A84C' }}>TJÄNSTER</h4>
<ul className="space-y-2 text-sm" style={{ color: '#9ca3af' }}>
{[
{ label: 'Standardstädning', key: 'standardstadning' },
{ label: 'Djupstädning', key: 'djupstadning' },
{ label: 'Flyttstädning', key: 'flyttstadning' },
{ label: 'Kontorsstädning', key: 'kontorsstadning' },
{ label: 'Månadspaket', key: 'manadspaket' },
{ label: 'Minipaket', key: 'minipaket' }
].map(t => (
<li key={t.key}
className="hover:text-white cursor-pointer transition-colors"
onClick={() => handleNavigate('momentlista', t.key)}>
{t.label}
</li>
))}
</ul>
</div>
<div>
<h4 className="font-bold mb-4 tracking-wider" style={{ color: '#C9A84C' }}>FÖRETAGET</h4>
<ul className="space-y-2 text-sm" style={{ color: '#9ca3af' }}>
{[
{ label: 'Om Galax', page: 'about' },
{ label: 'Vårt Team', page: 'team' },
{ label: 'Karriär', page: 'careers' },
{ label: 'Kontakt', page: 'contact' },
{ label: 'RUT-avdrag', page: 'rut' },
].map(({ label, page }) => (
<li key={page} className="hover:text-white cursor-pointer transition-colors"
onClick={() => handleNavigate(page)}>{label}</li>
))}
</ul>
</div>
<div>
<h4 className="font-bold mb-4 tracking-wider" style={{ color: '#C9A84C' }}>KONTAKT</h4>
<ul className="space-y-3 text-sm" style={{ color: '#9ca3af' }}>
<li>📍 Agneshögsgatan 24, Motala 591 70</li>
<li>📞 <a href="tel:0739414366" className="hover:text-white transition-colors">073-941-43-66</a></li>
<li>✉️ <a href="mailto:kontakt@galaxab.se" className="hover:text-white transition-colors">kontakt@galaxab.se</a></li>
</ul>
</div>
</div>
<div className="border-t pt-8 text-center text-sm" style={{ borderColor: '#2d2d4e', color: '#6b7280' }}>
<p>© 2026 Galax AB. Alla rättigheter förbehållna. | 50% RUT-avdrag på alla tjänster</p>
</div>
</div>
</footer>
)}
</div>
);
}

export default App;